import React from "react";
import { Link, useLocation } from "react-router-dom";

import MainBtn from "../repeats/mainBtn/MainBtn";
import Pros from "../pros/Pros";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";
import Post from "../blog/Post";

import clip from "../../assets/images/magal/clip.mp4";
import privateStorage from "../../assets/images/PS/privateStorage.jpg";
import online from "../../assets/images/PS/online.jpg";
import getback from "../../assets/images/PS/getback.jpg";
import img1 from "../../assets/images/Blog/1.jpg";
import "./Storage.css";
import { useEffect, useState } from "react";

const PrivateStorage = () => {
  const [start, setStart] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (start && location.hash !== '#top') {
      document.querySelector(".homeTitle").scrollIntoView();
      setStart(false);
    }
  }, [location, start]);

  const servicesArr = [
    {
      header: "אונליין",
      img: online,
      link: "/onlinestorage",
    },
    {
      header: "בעזרת נציג",
      img: getback,
      link: "/getbackStorage",
    },
  ];

  return (
    <>
      <div className="page_banner">
        <img src={privateStorage} alt="" />
        <div className="banner_content">
          <div className="banner_title">
            <h1>אחסנה פרטית</h1>
            <p>שירות בכל רחבי הארץ באמינות ודיוק ללא פשרות</p>
          </div>
          <div className="btnDiv">
            <MainBtn text="הצעת מחיר אונליין" link="/onlinestorage" />
            <MainBtn
              text="הזמנה בעזרת נציג"
              link="/getbackStorage"
              isLight={true}
            />
          </div>
        </div>
      </div>

      <Pros />

      <div className="servicesDiv">
        <h1 className="homeTitle">דרכי הזמנה</h1>
        <div className="services">
          {servicesArr.map((el, i) => {
            return (
              <Link to={el.link} key={i}>
                <div className="service">
                  <img src={el.img} alt="" />
                  <h1>{el.header}</h1>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

      <div className="about blog">
        {/* <h1 className="homeTitle">איך לארוז דירה</h1> */}
        <div className="clipWrapper">
          <video
            className="clip"
            playsInline
            src={clip}
            autoPlay={true}
            muted={true}
            controls
          />
        </div>
      </div>

      <Reviews />

      <div className="articlesDiv">
        <Post
          title="טיפים לאריזה"
          img={img1}
          text="  לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית קולהע צופעט למרקוח איבן איף, ברומץ כלרשט מיחוצים. קלאצי קולורס מונפרד אדנדום סילקוף, מרגשי ומרגשח. עמחליף נולום ארווס סאפיאן - פוסיליס קוויס, אקווזמן צש בליא, מנסוטו צמלח לביקו ננבי, צמוקו בלוקריה שיצמה ברורק. קולהע צופעט למרקוח איבן איף, ברומץ כלרשט מיחוצים. קלאצי לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סת אלמנקום ניסי נון ניבאה. דס איאקוליס וולופטה דיאם. וסטיבולום אט דולור, קראס אגת לקטוס וואל אאוגו וסטיבולום סוליסי טידום בעליק. קונדימנטום קורוס בליקרה, נונסטי קלובר בריקנה סטום, לפריקך תצטריק לרטי.        נולום ארווס סאפיאן - פוסיליס קוויס, אקווזמן קוואזי במר מודוף.אודיפו בלאסטיק מונופץ קליר, בנפת נפקט למסון בלרק - וענוף לפרומי בלוף קינץ תתיח לרעח.לת צשחמי מוסן מנת.להאמית קרהשק סכעיט דז מא, מנכם למטכין נשואי מנורך.קונסקטורר אדיפיסינג אלית.סת אלמנקום ניסי נון ניבאה.דס איאקוליס וולופטה דיאם.וסטיבולום אט דולור, קראס אגת לקטוס וואל אאוגו וסטיבולום סוליסי טידום בעליק.קונדימנטום קורוס בליקרה, נונסטי קלובר בריקנה סטום, לפריקך תצטריק לרטי.         קולורס מונפרד אדנדום סילקוף, מרגשי ומרגשח.עמחליף נולום ארווס סאפיאן - פוסיליס קוויס, אקווזמן קוואזי במר מודוף.אודיפו בלאסטיק מונופץ קליר, בנפת נפקט למסון בלרק - וענוף ליבם סולגק.בראיט ולחת צורק מונחף, בגורמי מגמש.תרבנך וסתעד לכנו סתשם השמה - לתכי מורגם בורק ? לתיג ישבעס.        קונדימנטום קורוס בליקרה, נונסטי קלובר בריקנה סטום, לפריקך תצטריק לרטי.        לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית.סת אלמנקום ניסי נון ניבאה.דס איאקוליס וולופטה דיאם.וסטיבולום אט דולור, קראס אגת לקטוס וואל אאוגו וסטיבולום סוליסי טידום בעליק.הועניב היושבב שערש שמחויט - שלושע ותלברו חשלו שעותלשך וחאית נובש ערששף.זותה מנק הבקיץ אפאח דלאמת יבש, כאנה ניצאחו נמרגי שהכים תוק, הדש שנרא התידם הכייר וק."
        />
      </div>

      <Footer isContact={true} />
    </>
  );
};

export default PrivateStorage;
